import { capitalizeFirstLetter } from "./dataUtils";

const getStatusFromId = (id: number) => {
  let status = "";
  switch (id) {
    case 1:
      status = "STARTED";
      break;
    case 2:
      status = "MERCHANT_ACCEPTED";
      break;
    case 3:
      status = "MERCHANT_COMPLETED";
      break;
    case 4:
      status = "IN_COLLECTION";
      break;
    case 5:
      status = "AT_HUB";
      break;
    case 6:
      status = "IN_TRANSIT";
      break;
    case 7:
      status = "COMPLETED";
      break;
    case 8:
      status = "MERCHANT_DECLINED"; // CANCELLED
      break;
    case 9:
      status = "WAITING FOR MERCHANT"; //"PENDING";
      break;
    case 10:
      status = "PAYMENT_PENDING";
      break;
    case 11:
      status = "PAYMENT_FAILED";
      break;
    default:
      status = "STATUS_UNKNOWN";
  }

  return capitalizeFirstLetter(status.replace(/_/gi, " "));
};

export { getStatusFromId };
